module.exports = __webpack_public_path__ + "static/img/donate-collabor-logo.6c73558.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/donate-collabor-logo.png
// module id = BUJ2
// module chunks = 1